module.exports = __webpack_public_path__ + "img/logo_no_bg.8e0b3544.png";